import { getFile } from "./client.js";
import { getLanguage } from "@mmm/ui";
async function triggerDownload(queryName: string, input: Record<string, unknown>): Promise<void> {
  const file = await getFile(queryName, input);
  const url = URL.createObjectURL(file.blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.filename;
  document.body.append(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function downloadTestDocument(input: { testId: string; format: "pdf" | "docx"; includeMemorandum?: boolean }): Promise<void> {
  return triggerDownload("exportTestDocument", input);
}

export function downloadStudyNotes(input: {
  subjectId: string;
  chapterId?: string;
  format: "pdf" | "docx";
  /** Subject-scoped only: append every chapter after the subject's own content. */
  includeChapters?: boolean;
}): Promise<void> {
  // The document carries a little text of its own -- the line under a node with
  // no writing yet -- so the server is told which language to render it in.
  return triggerDownload("exportStudyNotes", { ...input, locale: getLanguage() });
}
